// src/routes/ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, userData, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f5f7fa'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #e2e8f0',
          borderTopColor: '#667eea',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }} />
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin requirement
  if (requireAdmin) {
    const isAdmin = userData?.role === 'admin' ;
    
    if (!isAdmin) {
      // Auto logout non-admin users and redirect to login
      return <UnauthorizedAccess />;
    }
  }

  // Check if account is active
  if (userData && !userData.isActive) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f5f7fa',
        padding: '20px',
        textAlign: 'center'
      }}>
        <div style={{
          background: 'white',
          padding: '48px',
          borderRadius: '24px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          maxWidth: '500px'
        }}>
          <h2 style={{ fontSize: '24px', marginBottom: '12px', color: '#1e293b' }}>
            Compte désactivé
          </h2>
          <p style={{ color: '#64748b' }}>
            Votre compte a été désactivé. Veuillez contacter l'administrateur.
          </p>
        </div>
      </div>
    );
  }

  // Authenticated and authorized - render children
  return children;
};

export default ProtectedRoute;

// UnauthorizedAccess component
const UnauthorizedAccess = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Auto logout after 2 seconds
    const timer = setTimeout(async () => {
      await logout();
      navigate('/login', { replace: true });
    }, 2000);

    return () => clearTimeout(timer);
  }, [logout, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',  
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f5f7fa',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'white',
        padding: '48px',
        borderRadius: '24px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        maxWidth: '500px'
      }}>
        <h2 style={{ fontSize: '24px', marginBottom: '12px', color: '#1e293b' }}>
          Accès non autorisé
        </h2>
        <p style={{ color: '#64748b' }}>
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          Vous allez être déconnecté.
        </p>
      </div>
    </div>
  );
};